import { render, staticRenderFns } from "./FormRowItem.vue?vue&type=template&id=a3e049c2&scoped=true&"
import script from "./FormRowItem.vue?vue&type=script&lang=ts&"
export * from "./FormRowItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e049c2",
  null
  
)

export default component.exports